module.exports = __webpack_public_path__ + "fonts/opensans-semibolditalic.43e807c1.ttf";